var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-edit-dialog',{on:{"close":function($event){return _vm.update()},"save":function($event){return _vm.update()}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_vm._t("input")]},proxy:true}],null,true)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }